import { createContext, useState, useContext, FC } from 'react';

interface NotificationState  {
    quantity: number;
}


interface NotificationContextData { 
    notifications: NotificationState
    updateNotification(notication: NotificationState): void
    getNotification(): NotificationState
    addNotification(): void
}

const NotificationContext = createContext<NotificationContextData>({} as NotificationContextData)

const NotificationProvider: FC = ({ children }) => { 
    const [data, setData] = useState<NotificationState>({quantity: 0 });

    const addNotification = () => {         
        setData({ quantity: data.quantity + 1})
    }

    const updateNotification = (notification: NotificationState ) => {
        setData(notification)
    }

    const getNotification = () => { 
        return data
    }

    return ( 
        <NotificationContext.Provider value={{ notifications: {quantity: data.quantity}, updateNotification, getNotification, addNotification}}>
            {children}
        </NotificationContext.Provider>
    )
}

function useNotification(): NotificationContextData {
    const context = useContext(NotificationContext);
  
    return context;
  }
  
  export { NotificationProvider, useNotification };